export const salaryComponents = [
  {
    id: 1,
    componentName: "Basic Salary",
    type: "Earning",
    calculationType: "Fixed",
    amount: 25000,
    taxable: true,
    status: "Active",
  },
  {
    id: 2,
    componentName: "House Rent Allowance",
    type: "Earning",
    calculationType: "Fixed",
    amount: 10000,
    taxable: true,
    status: "Active",
  },
  {
    id: 3,
    componentName: "Special Allowance",
    type: "Earning",
    calculationType: "Fixed",
    amount: 5000,
    taxable: true,
    status: "Active",
  },
  {
    id: 4,
    componentName: "Provident Fund",
    type: "Deduction",
    calculationType: "Percentage",
    amount: 1800,
    taxable: false,
    status: "Active",
  },
  {
    id: 5,
    componentName: "Professional Tax",
    type: "Deduction",
    calculationType: "Fixed",
    amount: 200,
    taxable: false,
    status: "Active",
  },
];
export const salaryStructures = [
  {
    id: 1,
    structureName: "Software Engineer",
    department: "Engineering",
    description:
      "Standard salary structure for software engineers.",
    components: [
      "Basic Salary",
      "House Rent Allowance",
      "Medical Allowance",
      "Provident Fund",
      "Professional Tax",
    ],
    status: "Active",
  },
  {
    id: 2,
    structureName: "HR Executive",
    department: "HR",
    description:
      "Salary structure for HR executives.",
    components: [
      "Basic Salary",
      "House Rent Allowance",
      "Travel Allowance",
      "Provident Fund",
    ],
    status: "Active",
  },
  {
    id: 3,
    structureName: "Finance Executive",
    department: "Finance",
    description:
      "Salary structure for finance department employees.",
    components: [
      "Basic Salary",
      "Medical Allowance",
      "Special Allowance",
      "Professional Tax",
    ],
    status: "Inactive",
  },
];
export const employees = [
  {
    employeeId: "EMP001",
    employeeName: "Rahul Sharma",
    department: "Engineering",
    designation: "Software Engineer",
  },
  {
    employeeId: "EMP002",
    employeeName: "Priya Verma",
    department: "HR",
    designation: "HR Executive",
  },
  {
    employeeId: "EMP003",
    employeeName: "Amit Kumar",
    department: "Finance",
    designation: "Finance Executive",
  },
  {
    employeeId: "EMP004",
    employeeName: "Sneha Reddy",
    department: "Engineering",
    designation: "Senior Software Engineer",
  },
  {
    employeeId: "EMP005",
    employeeName: "Kiran Patel",
    department: "Sales",
    designation: "Sales Executive",
  },
];
export const employeeSalaryAssignments = [
  {
    id: 1,
    employeeId: "EMP001",
    employeeName: "Rahul Sharma",
    department: "Engineering",
    designation: "Software Engineer",
    salaryStructure: "Software Engineer",
    effectiveDate: "2026-07-01",
    status: "Active",
    remarks: "Initial salary assignment",
  },
  {
    id: 2,
    employeeId: "EMP002",
    employeeName: "Priya Verma",
    department: "HR",
    designation: "HR Executive",
    salaryStructure: "HR Executive",
    effectiveDate: "2026-07-05",
    status: "Active",
    remarks: "Confirmed employee",
  },
  {
    id: 3,
    employeeId: "EMP003",
    employeeName: "Amit Kumar",
    department: "Finance",
    designation: "Finance Executive",
    salaryStructure: "Finance Executive",
    effectiveDate: "2026-07-10",
    status: "Inactive",
    remarks: "Pending salary revision",
  },
];

export const payrollProcessing = [
  {
    id: 1,
    employeeId: "EMP001",
    employeeName: "Rahul Sharma",
    salaryStructure: "Software Engineer",
    grossSalary: 50000,
    deductions: 4200,
    netSalary: 45800,
    month: "July",
    year: "2026",
    status: "Processed",
    remarks: "Salary processed successfully",
  },
  {
    id: 2,
    employeeId: "EMP002",
    employeeName: "Priya Verma",
    salaryStructure: "HR Executive",
    grossSalary: 42000,
    deductions: 2500,
    netSalary: 39500,
    month: "July",
    year: "2026",
    status: "Pending",
    remarks: "Awaiting approval",
  },
  {
    id: 3,
    employeeId: "EMP003",
    employeeName: "Amit Kumar",
    salaryStructure: "Finance Executive",
    grossSalary: 46000,
    deductions: 3100,
    netSalary: 42900,
    month: "July",
    year: "2026",
    status: "Draft",
    remarks: "Draft payroll",
  },
  {
    id: 4,
    employeeId: "EMP004",
    employeeName: "Sneha Reddy",
    salaryStructure: "Software Engineer",
    grossSalary: 58000,
    deductions: 5000,
    netSalary: 53000,
    month: "July",
    year: "2026",
    status: "Processed",
    remarks: "Payroll completed",
  },
  {
    id: 5,
    employeeId: "EMP005",
    employeeName: "Kiran Patel",
    salaryStructure: "Finance Executive",
    grossSalary: 47000,
    deductions: 2800,
    netSalary: 44200,
    month: "July",
    year: "2026",
    status: "Pending",
    remarks: "Pending verification",
  },
];